import { BrowserRouter, Switch, Route, HashRouter } from 'react-router-dom';

import React, { Component } from 'react';
import NotFound from 'LIBRARY/CommonResources/NotFound/NotFound';
import StockVerification from 'LIBRARY/Components/StockVerification/StockVerification';
import ScannedResources from 'LIBRARY/Components/StockVerification/ScannedResources';
import ResourceStatus from 'LIBRARY/Components/ResourceStatus/ResourceStatus';
import Settings from 'LIBRARY/Components/Settings/Settings';
import CallIndexSeries from 'LIBRARY/Components/Settings/CallIndexSeries/CallIndexSeries';
import GrantAccess from 'LIBRARY/Components/Settings/GrantAccess/GrantAccess';

//Student Imports 
import StudentDashboard from 'LIBRARY/Components/StudentComponents/Dashboard/StudentDashboard';
import config from 'config';
import { IssueReturn } from 'LIBRARY/Components/IssueReturn/IssueReturn';
import { Resource } from 'LIBRARY/Components/Resource/Resource';
import  Periodicals  from 'LIBRARY/Components/Periodicals/Periodicals.js';
import { Eresources } from 'LIBRARY/Components/Eresources/Eresources';
import { Rules } from 'LIBRARY/Components/Rules/Rules';
import { LibraryEntry } from 'LIBRARY/Components/LibraryEntry/LibrarayEntry';
import { Publisher } from 'LIBRARY/Components/Publisher/Publisher';
import { DonarList } from '../Components/DonorList/DonorList.js';
import { ResourceCategory } from 'LIBRARY/Components/ResourceCategory/ResourceCategory.js';
import { ResourceLocation } from 'LIBRARY/Components/ResourceLocation/ResourceLocation.js';
import { Requisition } from 'LIBRARY/Components/Requisition/Requisition.js';
import { PurchaseRequest } from 'LIBRARY/Components/PurchaseRequest/PurchaseRequest.js';
import { Reports } from 'LIBRARY/Components/Reports/Reports.js';
import PrintBarcode from 'LIBRARY/Components/PrintBarcode/PrintBarcode.js';
import Membership from 'LIBRARY/Components/Membership/Membership.js';
import Invoice from 'LIBRARY/Components/Invoices/Invoices.js';
import { connect } from 'react-redux';
import LibraryApiCall from 'LibraryApiCall.js';
// import { getAdminDetails } from 'LIBRARY/Actions/AdminDetailsAction.js';
import { Resources } from 'LIBRARY/Components/User/Resources/Resources.js';
import { Dashboard } from 'LIBRARY/Components/Dashboard/Dashboard.js';
import { userEresources } from '../Components/User/userEresources/userEresources.js';
import { UserPeriodicals } from 'LIBRARY/Components/User/UserPeriodicals/UserPeriodicals.js';
import { UserRules } from 'LIBRARY/Components/User/UserRules/UserRules.js';
import { UserIssuedResources } from 'LIBRARY/Components/User/UserIssuedResources/UserIssuedResources.js';
import { UserRequisition } from 'LIBRARY/Components/User/UserRequisition/UserRequisition.js';
import { UserResourceCategory } from 'LIBRARY/Components/User/UserResourceCategory/UserResourceCategory.js';
import { getLibraryAccessDetails, setAssignedInstitute, setAssignedIIdArray, getAssignedIIDArray, getAssignedInstituteObject } from 'LIBRARY/Actions/AdminDetailsAction.js';
import Store from 'LIBRARY/Store/Store.js';
import {UserDashboard} from 'LIBRARY/Components/User/userDashboard/userDashboard.js';
import NoDueCertificate from 'LIBRARY/Components/NoDueCertificate/NoDueCertificate.js';
import Spinner from 'LIBRARY/CommonResources/SpinnerLoader/Spinner';
import ResourceDetails from 'LIBRARY/Components/ResourceDetails/resourceDetails.js';
import DisableInspect from 'LIBRARY/CommonResources/DisableInspects.js';
import LibraryIntegration from 'LIBRARY/Components/LibraryIntegration/LibraryIntegration.js';
import ReserveABook from 'LIBRARY/Components/ReserveABook/ReserveABook.js';
import ReserveABookForAdmin from 'LIBRARY/Components/ReserveABookAdmin/ReserveABookAdmin.js';
import IssueReturnResource from 'LIBRARY/Components/IssueReturn/IssueReturnResource.js';

export class RoutesSetup extends Component {

    constructor(props) {
        super(props);
        this.state={
            // dispatch: this.props.dispatch
        };
    }


    componentDidMount() { 
        // const { routingMenu, dispatch } = this.props;
        // METHOD TO GET EMPLOYEE ACCESS DETAILS
        if ((this.props.adminAccess) != "" || this.props.adminAccess == undefined) {
            // this.apiCallToGetLibraryAccess();
            Store.dispatch(getLibraryAccessDetails());
        }
        
        // this.GetInstructorAssignedInstituteList();
        if (Object.keys(this.props.routingMenu.accessibleScreens).length == 0) {
            // this.GetInstructorAssignedInstituteList();
            if(config.account === 'student'){
                this.apiToCallLinkedInstituteStatus();
            }else{
                this.apiToCallFacultyAssignedInstituteList();
            }
        }
    }

    checkAccessDetails() {
        const { routingMenu, dispatch } = this.props;

        if (Object.keys(this.props.routingMenu.accessDetails).length === 0) {
            dispatch(getLibraryAccessDetails());
        }
    }


    apiCallToGetLibraryAccess = async () => {
        let requestData = {
            iid: config.institute_id,
            facultyId: config.faculty_id
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            "GetLibraryAccessDetails",
            requestData,
            "/api/library/instructor.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetLibraryAccess();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.access_provided.library_admin.isAccessGranted;
                this.props.DispatchgetAdminDetails(apiResult);


            } else {
                this.setState({
                    subscriptionResponseReceived: true,
                    successModal: true,
                    successModalType: "error",
                    successMessage:
                        "Something went wrong while getting subscription model access data list. Please try again later.",
                });
            }
        }

    }

    GetInstructorAssignedInstituteList = async () => {

        let requestData = {
            facultyId: config.faculty_id
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            "GetInstructorAssignedInstituteList",
            requestData,
            "/api/management/management.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetInstructorAssignedInstituteList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let iidArray = [];
                let apiResult = jsonResponse.APIResult.data;
                Object.values(apiResult).map((stream, index) => {
                    iidArray.push(stream.iid);
                });
                // dispatch(setAssignedInstitute(jsonResponse.APIResult.data)); 
                this.props.DispatchAssignedInstituteId(jsonResponse.APIResult.data);
                this.props.DispatchIIDArray(iidArray);
                // dispatch(setAssignedInstitute(jsonResponse.APIResult.data));           
                setAssignedInstitute(jsonResponse.APIResult.data)
                setAssignedIIdArray(iidArray)
            }
            else {
                this.setState({
                    subscriptionResponseReceived: true,
                    successModal: true,
                    successModalType: "error",
                    successMessage:
                        "Something went wrong while getting subscription model access data list. Please try again later.",
                });
            }
        }

    }

    // get linked institutes for student
    apiToCallLinkedInstituteStatus = async () => {

        let requestData = {
            "iid": config.institute_id
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'library_GetLinkedInstituteStatus',
            requestData,
            '/api/library/libraryLinkInstitute.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiToCallLinkedInstituteStatus()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                this.props.dispatchAssignedIIDArray({iidArray:apiResult.linkedIidArray});
                this.props.dispatchAssignedIIDObject({multipleInstituteDetails: apiResult.linkedInstituteData});
            }
        }

    }

    // get linked institutes for faculty
    apiToCallFacultyAssignedInstituteList = async () => {
        let requestData = {
            "facultyId": config.faculty_id,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'library_GetFacultyAssignedInstituteList',
            requestData,
            '/api/library/libraryLinkInstitute.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiToCallFacultyAssignedInstituteList()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;
                if (apiResult?.success == 'true') {

                    this.props.dispatchAssignedIIDArray({iidArray:apiResult.linkedIidArray});
                    this.props.dispatchAssignedIIDObject({multipleInstituteDetails: apiResult.data});
                }
            }
        }
    }

    render() {
        const { routingMenu, dispatch } = this.props;
        
        return (
            <>
                <DisableInspect />
                <HashRouter>
                    {
                        config.instructorInfo.account == 'faculty' ?

                            <Switch>
                                <Route exact path="/" component={UserDashboard} />
                                <Route exact path="/user/resource/:id" component={Resources} />
                                <Route exact path="/user/resource" component={UserResourceCategory} />
                                <Route exact path="/user/eresoures" component={userEresources} />
                                <Route exact path="/user/periodicals" component={UserPeriodicals} />
                                <Route exact path="/user/rules" component={UserRules} />
                                <Route exact path="/user/issuedresources" component={UserIssuedResources} />
                                <Route exact path="/user/requisition" component={UserRequisition} />
                                <Route exact path="/user/reserveABook" component={ReserveABook} />

                                {routingMenu.isLibraryAdmin ?
                                    <>
                                        <Route exact path="/dashboard" component={Dashboard} />
                                        <Route exact path="/printbarcode" component={PrintBarcode} />
                                        <Route exact path="/stockverification" component={StockVerification} />
                                        <Route exact path="/scannedresources" component={ScannedResources} />
                                        <Route exact path="/periodicals" component={Periodicals} />
                                        <Route exact path="/resourceStatus" component={ResourceStatus} />
                                        <Route exact path="/callIndexSeries" component={CallIndexSeries} />
                                        <Route exact path="/settings" component={Settings} />
                                        <Route exact path="/issuereturn" component={IssueReturn} />
                                        <Route exact path="/resource" component={Resource} />
                                        <Route exact path="/eresources" component={Eresources} />
                                        {/* <Route exact path="/rules" component={Rules} /> */}
                                        <Route exact path="/libraryentry" component={LibraryEntry} />
                                        <Route exact path="/publisher" component={Publisher} />
                                        <Route exact path="/donorList" component={DonarList} />
                                        <Route exact path="/resourcecategory" component={ResourceCategory} />
                                        <Route exact path="/resourcelocation" component={ResourceLocation} />
                                        <Route exact path="/requisition" component={Requisition} />
                                        <Route exact path="/purchaserequest" component={PurchaseRequest} />
                                        <Route exact path="/reports/:id" component={Reports} />
                                        <Route exact path="/membership" component={Membership} />
                                        <Route exact path="/invoice" component={Invoice} />
                                        <Route exact path="/grantAccess" component={GrantAccess} />
                                        <Route exact path="/noDueCertificate" component={NoDueCertificate} />
                                        <Route exact path="/resourceDetails" component={ResourceDetails} />
                                        <Route exact path="/libraryIntegration" component={LibraryIntegration} />
                                        <Route exact path="/reserveABookForAdmin" component={ReserveABookForAdmin} />
                                        <Route exact path="/issueReturnResource" component={IssueReturnResource} />
                                    </>
                                    :
                                        this.props.adminAccess == "true" &&
                                            <>
                                                <Route exact path="/dashboard" component={Dashboard} />

                                                {
                                                    routingMenu.accessibleScreens && routingMenu.accessibleScreens.includes('resource') &&
                                                    <Route exact path="/resource" component={Resource} />
                                                }
                                                {
                                                    routingMenu.accessibleScreens && routingMenu.accessibleScreens.includes('issue/return') &&
                                                    <Route exact path="/issuereturn" component={IssueReturn} />
                                                }
                                                {
                                                    routingMenu.accessibleScreens && routingMenu.accessibleScreens.includes('issue/return') &&
                                                    <Route exact path="/issueReturnResource" component={IssueReturnResource} />
                                                }
                                                <Route exact path="/reserveABookForAdmin" component={ReserveABookForAdmin} />
                                                {
                                                    routingMenu.accessibleScreens && routingMenu.accessibleScreens.includes('periodicals') &&
                                                    <Route exact path="/periodicals" component={Periodicals} />
                                                }
                                                {
                                                    routingMenu.accessibleScreens && routingMenu.accessibleScreens.includes('e-resources') &&
                                                    <Route exact path="/eresources" component={Eresources} />
                                                }
                                                {/* {
                                                    routingMenu.accessibleScreens && routingMenu.accessibleScreens.includes('rules') &&
                                                    <Route exact path="/rules" component={Rules} />
                                                } */}
                                                {
                                                    routingMenu.accessibleScreens && routingMenu.accessibleScreens.includes('library entry') &&
                                                    <Route exact path="/libraryentry" component={LibraryEntry} />
                                                }
                                                {
                                                    routingMenu.accessibleScreens && routingMenu.accessibleScreens.includes('publisher') &&
                                                    <Route exact path="/publisher" component={Publisher} />
                                                }
                                                {
                                                    routingMenu.accessibleScreens && routingMenu.accessibleScreens.includes('donor list') &&
                                                    <Route exact path="/donorList" component={DonarList} />
                                                }
                                                {
                                                    routingMenu.accessibleScreens && routingMenu.accessibleScreens.includes('print barcode') &&
                                                    <Route exact path="/printbarcode" component={PrintBarcode} />
                                                }
                                                {
                                                    routingMenu.accessibleScreens && routingMenu.accessibleScreens.includes('stock verification') &&
                                                    <Route exact path="/stockverification" component={StockVerification} />
                                                }
                                                {
                                                    routingMenu.accessibleScreens && routingMenu.accessibleScreens.includes('resource category') &&
                                                    <Route exact path="/resourcecategory" component={ResourceCategory} />
                                                }
                                                {
                                                    routingMenu.accessibleScreens && routingMenu.accessibleScreens.includes('resource location') &&
                                                    <Route exact path="/resourcelocation" component={ResourceLocation} />
                                                }
                                                {
                                                    routingMenu.accessibleScreens && routingMenu.accessibleScreens.includes('resource requisition') &&
                                                    <Route exact path="/requisition" component={Requisition} />
                                                }
                                                {
                                                    routingMenu.accessibleScreens && routingMenu.accessibleScreens.includes('purchase request') &&
                                                    <Route exact path="/purchaserequest" component={PurchaseRequest} />
                                                }
                                                {
                                                    routingMenu.accessibleScreens && routingMenu.accessibleScreens.includes('reports') &&
                                                    <Route exact path="/reports/:id" component={Reports} />
                                                }
                                                {
                                                    routingMenu.accessibleScreens && routingMenu.accessibleScreens.includes('membership') &&
                                                    <Route exact path="/membership" component={Membership} />
                                                }
                                                {
                                                    routingMenu.accessibleScreens && routingMenu.accessibleScreens.includes('invoice') &&
                                                    <Route exact path="/invoice" component={Invoice} />
                                                }
                                                {
                                                    routingMenu.accessibleScreens && routingMenu.accessibleScreens.includes('setting') &&
                                                    <Route exact path="/settings" component={Settings} />
                                                }
                                                {
                                                    routingMenu.accessibleScreens && routingMenu.accessibleScreens.includes('noDueCertificate') &&
                                                    <Route exact path="/noDueCertificate" component={NoDueCertificate} />
                                                }
                                                {
                                                    routingMenu.accessibleScreens && routingMenu.accessibleScreens.includes('resource') &&
                                                    <Route exact path="/resourceDetails" component={ResourceDetails} />
                                                }
                                                <Route exact path="/scannedresources" component={ScannedResources} />
                                                <Route exact path="/resourceStatus" component={ResourceStatus} />
                                                <Route exact path="/callIndexSeries" component={CallIndexSeries} />
                                                <Route exact path="/grantAccess" component={GrantAccess} />
                                                <Route exact path="/libraryIntegration" component={LibraryIntegration} />
                                            </>
                                    
                                }

                                <Route path="*" component={Spinner} />
                                {/* <Route path="*" component={NotFound} /> */}
                            </Switch>

                            :
                            <Switch>
                                <Route exact path="/" component={UserDashboard} />
                                <Route exact path="/user/resource/:id" component={Resources} />
                                <Route exact path="/user/resource" component={UserResourceCategory} />
                                <Route exact path="/user/eresoures" component={userEresources} />
                                <Route exact path="/user/periodicals" component={UserPeriodicals} />
                                <Route exact path="/user/rules" component={UserRules} />
                                <Route exact path="/user/issuedresources" component={UserIssuedResources} />
                                <Route exact path="/user/requisition" component={UserRequisition} />
                                <Route exact path="/user/reserveABook" component={ReserveABook} />
                                {/* <Route path="*" component={NotFound} /> */}
                                <Route path="*" component={Spinner} />
                            </Switch>
                    }
                </HashRouter>
            </>
        )
    }
}


const mapStateToProps = store => {
    return {
        // VARIABLES TO GET AGENCY DETAILS
        adminAccess: store.RouteMenuReducer.accessDetails == true ? "true" : "false",
        routingMenu: store.RouteMenuReducer 
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        // METHOD TO GET admin DETAILS
        // DispatchgetAdminDetails: (apiResult) => dispatch(getAdminDetails(apiResult)),
        DispatchAssignedInstituteId: (apiResult) => dispatch(setAssignedInstitute(apiResult)),
        DispatchIIDArray: (apiResult) => dispatch(setAssignedIIdArray(apiResult)),
        dispatchAssignedIIDObject:(apiResult) => dispatch(getAssignedInstituteObject(apiResult)),
        dispatchAssignedIIDArray:(apiResult) => dispatch(getAssignedIIDArray(apiResult)),
    };
}

    ;
export default connect(mapStateToProps, mapDispatchToProps)(RoutesSetup);

